// Select all 'ul.award-scroll__items' elements on the page
const awardGroups = document.querySelectorAll('.award-scroll__items');

if (awardGroups) {
  // Function to clone and append 'li.award-scroll__item' items for a specific 'ul'
  const cloneAndAppendLiItems = (ul, times) => {
    const awardItems = Array.from(ul.querySelectorAll('.award-scroll__item')); // Clone all 'li' elements in this specific 'ul'

    for (let i = 0; i < times; i++) {
      awardItems.forEach((li) => {
        const clonedLi = li.cloneNode(true); // Clone each 'li' element
        ul.appendChild(clonedLi); // Append cloned 'li' to this 'ul'
      });
    }
  };

  // Apply the cloning logic to each 'ul' element
  awardGroups.forEach((ul) => {
    cloneAndAppendLiItems(ul, 3); // Append cloned 'li' items 3 times for each 'ul'
  });
}
